var QuestionType = {

      Unknown        : 'Unknown' 
    , Text           : 'Text' 
    , Numeric        : 'Numeric' 
    , SingleChoice   : 'SingleChoice' 
    , MultipleChoice : 'MultipleChoice' 
    , DateTime       : 'DateTime' 
    , YesNo          : 'YesNo' 
    , Id             : 'Id' 
    , Date           : 'Date' 
    , Time           : 'Time' 
    , Picture        : 'Picture' 
    , Signature      : 'Signature' 


}

module.exports = QuestionType;